module.exports = __webpack_public_path__ + "img/client1.589c5133.png";